import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';
import 'zone.js/dist/zone-error';

export const iamloveCustomerGroup = 'iamlove';
export const customerGroup = iamloveCustomerGroup;

const supportEmail = {
	iamlove: 'iamlove@smoothr.de',
};
const firebaseConfig = {
	iamlove: {
		apiKey: "AIzaSyBx3rlbR5y81d9sWT4DJEfDlqFyqUmXaz0",
		authDomain: "dev-env-216009.firebaseapp.com",
		databaseURL: "https://dev-env-216009.firebaseio.com",
		projectId: "dev-env-216009",
		storageBucket: "dev-env-216009.appspot.com",
		messagingSenderId: "1004449889395",
		appId: "1:1004449889395:web:1323da5b94483276e0fe06",
		measurementId: "G-Z3VHY57E21"
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDsuWzpCo2sJECUUmkKfRaQ-jdqJcp1uvM',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
};
